import { render, staticRenderFns } from "./firstNotice.vue?vue&type=template&id=fde33fcc&scoped=true&"
import script from "./firstNotice.vue?vue&type=script&lang=js&"
export * from "./firstNotice.vue?vue&type=script&lang=js&"
import style0 from "./firstNotice.vue?vue&type=style&index=0&id=fde33fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde33fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde33fcc')) {
      api.createRecord('fde33fcc', component.options)
    } else {
      api.reload('fde33fcc', component.options)
    }
    module.hot.accept("./firstNotice.vue?vue&type=template&id=fde33fcc&scoped=true&", function () {
      api.rerender('fde33fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/firstNotice.vue"
export default component.exports